var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPdf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6665 2.5V5.83333C11.6665 6.05435 11.7543 6.26631 11.9106 6.42259C12.0669 6.57887 12.2788 6.66667 12.4998 6.66667H15.8332M11.6665 2.5H5.83317C5.39114 2.5 4.96722 2.67559 4.65466 2.98816C4.3421 3.30072 4.1665 3.72464 4.1665 4.16667V10M11.6665 2.5L15.8332 6.66667M15.8332 6.66667V10M4.1665 15H5.4165C5.74802 15 6.06597 14.8683 6.30039 14.6339C6.53481 14.3995 6.6665 14.0815 6.6665 13.75C6.6665 13.4185 6.53481 13.1005 6.30039 12.8661C6.06597 12.6317 5.74802 12.5 5.4165 12.5H4.1665V17.5M14.1665 15H15.8332M16.6665 12.5H14.1665V17.5M9.1665 12.5V17.5H9.99984C10.4419 17.5 10.8658 17.3244 11.1783 17.0118C11.4909 16.6993 11.6665 16.2754 11.6665 15.8333V14.1667C11.6665 13.7246 11.4909 13.3007 11.1783 12.9882C10.8658 12.6756 10.4419 12.5 9.99984 12.5H9.1665Z",
    stroke: "#B91C1C",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPdf);
export default __webpack_public_path__ + "static/media/icon-pdf.f9365baf6ede53aaba83b8f7b0029ba7.svg";
export { ForwardRef as ReactComponent };